import { Typography } from '@euler/app/components/typography';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { Volume2, VolumeX } from 'lucide-react-native';
import { ReactNode, memo } from 'react';
import { TouchableOpacity, View } from 'react-native';
import { aiColors } from '../../../../../ai-suite/theme';

/** The case under the top bar, and the customer's voice on or off. */
export const SceneSubheader = memo(
  ({
    title,
    speak,
    onToggleSpeak,
    extra,
  }: {
    title: string;
    speak: boolean;
    onToggleSpeak: () => void;
    /** Beside the toggle: a call's timer. */
    extra?: ReactNode;
  }) => {
    const { rpx } = useResponsiveContext();
    const Speaker = speak ? Volume2 : VolumeX;
    return (
      <View
        style={{
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: rpx(12),
          paddingHorizontal: rpx(16),
          paddingVertical: rpx(8),
          borderBottomWidth: 1,
          borderBottomColor: aiColors.border,
          backgroundColor: aiColors.card,
        }}
      >
        <Typography.Text
          size={rpx(11)}
          color={aiColors.mutedForeground}
          numberOfLines={1}
          style={{ flex: 1 }}
        >
          {title}
        </Typography.Text>
        {extra}
        <TouchableOpacity
          accessibilityRole="button"
          accessibilityLabel={speak ? '静音' : '打开声音'}
          onPress={onToggleSpeak}
          hitSlop={8}
          style={{ flexDirection: 'row', alignItems: 'center', gap: rpx(4) }}
        >
          <Speaker size={rpx(14)} color={aiColors.mutedForeground} />
          <Typography.Text size={rpx(11)} color={aiColors.mutedForeground}>
            {speak ? '静音' : '已静音'}
          </Typography.Text>
        </TouchableOpacity>
      </View>
    );
  },
);
